import React from "react";
import RichTextPage from "../RichTextPage";

/**
 * Hakkımızda sayfası metni — Türkçe `About` (çift base64), çeviriler `About_Lang`.
 *
 * Önceden ayrı bir kopya olarak yazılmıştı; bir dilde kaydedince diğer
 * sekmelerdeki kaydedilmemiş metinler siliniyordu. Artık Üretim ve KVKK
 * ekranlarıyla aynı ortak düzenleyiciyi kullanıyor.
 */
export default function AboutTranslations() {
  return (
    <RichTextPage
      pageTitle="Hakkımızda Metni"
      description="Hakkımızda sayfasının metni bu ekrandan yönetilir."
      where="Metin, sitedeki Hakkımızda sayfasında ve mobil uygulamadaki Hakkımızda ekranında görünür. Sağdaki künye kartı ve alttaki kilometre taşları sabittir. Tanıtım filmi 'Site Görselleri' ekranındaki 'Hakkımızda — tanıtım filmi' yuvasından eklenir."
      note="Adres, telefon ve sosyal medya hesapları burada değil — onlar için 'İletişim Bilgileri' ekranını kullanın."
      links={[{ label: 'Hakkımızda sayfası', path: '/hakkimizda' }]}
      trTable="About"
      trField="About_Html"
      trBinary
      langTable="About_Lang"
      langField="About_Html"
    />
  );
}
